var _rect, _rect2, _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndicators(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "var(--app-icons-color)",
    x: 3.1,
    y: 15.82,
    width: 4.9,
    height: 4.61
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "var(--app-icons-color)",
    x: 9.71,
    y: 11.59,
    width: 4.9,
    height: 8.83
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--app-icons-color)",
    d: "M2.27,1.21H1.07V22.65a.62.62,0,0,0,.6.6h21v-1.2H2.27Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "17.17 6.77 16.45 7.69 16.45 7.93 17.36 6.77 17.17 6.77"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "18.09 6.77 16.45 8.86 16.45 9.1 18.28 6.77 18.09 6.77"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "19.02 6.77 16.45 10.02 16.45 10.26 19.2 6.77 19.02 6.77"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "19.94 6.77 16.45 11.19 16.45 11.43 20.13 6.77 19.94 6.77"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "20.86 6.77 16.45 12.36 16.45 12.6 21.05 6.77 20.86 6.77"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "21.33 7.35 16.45 13.52 16.45 13.76 21.33 7.59 21.33 7.35"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "21.33 8.51 16.45 14.69 16.45 14.93 21.33 8.75 21.33 8.51"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "21.33 9.68 16.45 15.86 16.45 16.1 21.33 9.92 21.33 9.68"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "21.33 10.85 16.45 17.02 16.45 17.26 21.33 11.09 21.33 10.85"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "21.33 12.02 16.45 18.19 16.45 18.43 21.33 12.25 21.33 12.02"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "21.33 13.18 16.45 19.36 16.45 19.6 21.33 13.42 21.33 13.18"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "16.88 20.22 21.33 14.59 21.33 14.35 16.69 20.22 16.88 20.22"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "17.8 20.22 21.33 15.75 21.33 15.51 17.61 20.22 17.8 20.22"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "18.72 20.22 21.33 16.92 21.33 16.68 18.53 20.22 18.72 20.22"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "19.64 20.22 21.33 18.09 21.33 17.85 19.45 20.22 19.64 20.22"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "20.57 20.22 21.33 19.25 21.33 19.01 20.38 20.22 20.57 20.22"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ff933c",
    x: 16.59,
    y: 6.98,
    width: 4.88,
    height: 13.45
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicators);
export default __webpack_public_path__ + "static/media/indicators.1da388d7.svg";
export { ForwardRef as ReactComponent };